import { Location } from "history";
import * as React from "react";
import { useLocation } from "react-router-dom";

import matchEndOfPath from "./matchEndOfPath";

type Props = {
  children: React.ReactElement<any>;
  location?: Location;
};

export default function PathEndsWithSwitch({
  children: routes,
  location: _location
}: Props) {
  let element: any, match: any;

  const hookLocation = useLocation();

  const location = _location || hookLocation;

  // We use React.Children.forEach instead of React.Children.toArray().find()
  // here because toArray adds keys to all child elements and we do not want
  // to trigger an unmount/remount for two <Route>s that render the same
  // component at different URLs.
  React.Children.forEach(routes, (route: any) => {
    if (!match && React.isValidElement(route)) {
      element = route;

      // Props from `MatchEndOfPath*` routes
      const path =
        (route.props as any).pathEndsWith ||
        (route.props as any).pathsEndingWith;

      const paths = Array.isArray(path) ? path : [path];

      match = paths.some(path =>
        matchEndOfPath(location.pathname, {
          path
        })
      );
    }
  });

  return match
    ? React.cloneElement(element, {
        location,
        computedMatch: match
      })
    : null;
}
